module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/company-cd4b97fa6235cfb3f34d8d5cb6dd6acf.svg";